import { HttpInterceptorFn } from "@angular/common/http";

/**
 * Append SESSION cookie to all outgoing requests by setting the withCredentials param.
 *
 * @author Mateusz Warzyc
 * @param req request
 * @param next request handler
 */
export const httpRequestWithCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const request = req.clone({
    withCredentials: true,
  });
  return next(request);
};
